
import { useEffect } from 'react';

export function useScrollAnimation() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          } else {
            entry.target.classList.remove('animate-in');
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    const observeAll = () => {
      document.querySelectorAll('[data-animate]').forEach((el) => observer.observe(el));
    };

    observeAll();

    // Re-observa elementos ao redimensionar (comum em mobile ao girar tela)
    window.addEventListener('resize', observeAll);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', observeAll);
    };
  }, []);
}
